import { z } from "zod";

/**
 * SMS sending configuration
 */
export const PhoneCallSendSmsSchema = z.object({
  name: z.string(),
  description: z.string(),
  contentDescription: z.string().optional()
});

export type PhoneCallSendSms = z.infer<typeof PhoneCallSendSmsSchema>;
